module.exports = __webpack_public_path__ + "img/industry.bbc09a5e.svg";